import { DataTable } from './components/data-table';

export const Inventory = () => {
  return (
    <div>
      <div>
        <h1>Inventory</h1>
        <DataTable />
      </div>
    </div>
  );
};
